import { render, staticRenderFns } from "./PsEventProduct.vue?vue&type=template&id=03090e2a&scoped=true&"
import script from "./PsEventProduct.vue?vue&type=script&lang=js&"
export * from "./PsEventProduct.vue?vue&type=script&lang=js&"
import style0 from "./PsEventProduct.vue?vue&type=style&index=0&id=03090e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03090e2a",
  null
  
)

export default component.exports